import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { type PatientSurfaceFlagVariant } from '@heidi/patients/contracts';
import { patientListFlag } from '@heidi/patients/flags';
import { OpenFeature } from '@openfeature/react-sdk';

/**
 * Resolves the feature-flag exposure cohort stamped on every patient-surface
 * event. Pre-GA the whole surface is gated, so any event firing implies a
 * treated user; we stamp the variant anyway so dashboards can slice by cohort
 * without joining an exposure log, and so the field is already correct once a
 * held-back control exists.
 *
 * Read via the non-hook OpenFeature client (mirrors `src/components/constants/
 * flags.ts`) and resolved at fire time, so it can be called from event handlers
 * and mutation callbacks without adding a React-hook / provider dependency to
 * every component that emits.
 */
export const resolvePatientSurfaceFlagVariant = (): PatientSurfaceFlagVariant => {
  if (process.env.NEXT_PUBLIC_FORCE_ENABLE_ALL_FEATURE_FLAGS === 'true') {
    return 'treated';
  }
  const isEnabled = OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    patientListFlag.key,
    false
  );
  return isEnabled ? 'treated' : 'control';
};
